// oxlint-disable no-named-as-default-member
// oxlint-disable prefer-await-to-callbacks
// oxlint-disable prefer-await-to-then
import {__APP_ENV__} from '@src/app_env';
import {getAnalyticsRequestHeaders} from '@src/plugins/analytics';
import {RouteNames} from '@src/router/route_names';
import type {AxiosInstance} from 'axios';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import type {Router} from 'vue-router';

/**
 * Create the app's axios instance: API base URL, cookies included, two
 * retries on network errors, and a redirect to sign-in on 401.
 */
export const createHttpInstance = (router: Router): AxiosInstance => {
   const instance = axios.create({
      baseURL: __APP_ENV__.API_URL,
      withCredentials: true,
   });

   axiosRetry(instance, {
      retries: 2,
      retryDelay: (retryCount: number) => {
         return retryCount * 1000;
      },
      retryCondition: (e) => {
         return axiosRetry.isNetworkError(e);
      },
      onRetry: (count, e) => {
         console.warn(`Retrying request [count: ${count}, error: ${e.message}, url: ${e.config?.url}]`);
         console.error(e);
      },
   });

   instance.interceptors.request.use((config) => {
      // Link the request to the caller's PostHog session and replay.
      for (const [key, value] of Object.entries(getAnalyticsRequestHeaders())) {
         config.headers.set(key, value);
      }
      return config;
   });

   instance.interceptors.response.use(
      (response) => {
         return response;
      },
      (error) => {
         console.info(`Axios Error Intercepted: status: [${error?.response?.status}] `, error);

         // 401: send the user to sign-in with a return path. Local auth state
         // is left alone; the server session is already invalid.
         if (error?.response?.status === 401) {
            console.warn('HTTP 401 intercepted — redirecting to sign-in');
            const redirect = router.currentRoute.value.fullPath;
            void router.push({name: RouteNames.AUTH_SIGN_IN, query: {redirect}});
         }

         throw error;
      },
   );

   return instance;
};

